import { LocalStorageKeys } from "../enums/localstorage-keys.enum"

export class LocalStorageService {

    static deleteAccessToken() {
        deleteItem(LocalStorageKeys.ACCESS_TOKEN)
    }

    static setAccessToken(accessToken) {
        setItem(LocalStorageKeys.ACCESS_TOKEN, accessToken)
    }

    static getAccessToken() {
        return getItem(LocalStorageKeys.ACCESS_TOKEN)
    }
}

const setItem = (key, value) => {
    localStorage.setItem(key, value)
}

const getItem = (key) => {
    return key && localStorage.getItem(key)
}

const deleteItem = (key) => {
    key && localStorage.removeItem(key)
}